/* global I18n */

import React, {useState} from "react"
import FaIcon from "../fa_icon"
import CheckboxEntry from "./checkbox_entry"
import MuscleFactsTags from "./muscle_facts_tags"
import ExpandableControls from "./expandable_controls"
import {use_configuration} from "./configuration_provider"

function AdvancedSettings({quiz}) {
  const {configuration, update_configuration} = use_configuration()
  const [settings_are_open, set_settings_are_open] = useState(false)
  const {muscle_facts_tags, question_count} = quiz

  function on_change(config, value, disable_exam_conditions) {
    update_configuration({
      [config]: configuration[config] === value ? "included" : value,
      ...(disable_exam_conditions && {exam_conditions: false})
    })
  }

  if (
    !muscle_facts_tags?.length &&
    !question_count?.spelling_exercises
  ) return

  return (
    <div className="control-group">
      <h4 onClick={() => set_settings_are_open(!settings_are_open)}>
        {I18n.t("js.quiz_mode_selector.advanced_settings")}
        {!settings_are_open && <FaIcon name={"fa-chevron-down"}/>}
        {settings_are_open && <FaIcon name={"fa-chevron-up"}/>}
      </h4>
      {settings_are_open &&
        <>
          {!!question_count.spelling_exercises &&
            <ExpandableControls
              onChange={() => on_change("spelling_exercises", "excluded")}
              checked={configuration.spelling_exercises !== "excluded"}
              title={I18n.t("js.quiz_mode_selector.spelling_exercises.label")}
            >
              <CheckboxEntry
                label={
                  I18n.t("js.quiz_mode_selector.spelling_exercises.ask_only")
                }
                checked={configuration.spelling_exercises === "only"}
                onChange={() => on_change("spelling_exercises", "only", true)}
              />
            </ExpandableControls>}
          {!!muscle_facts_tags.length &&
            <ExpandableControls
              onChange={() => on_change("muscle_facts", "excluded")}
              checked={configuration.muscle_facts !== "excluded"}
              title={I18n.t("js.quiz_mode_selector.muscle_facts.label")}
            >
              <MuscleFactsTags tags={muscle_facts_tags} />
              <div className="divider"></div>
              <CheckboxEntry
                label={I18n.t("js.quiz_mode_selector.muscle_facts.ask_only")}
                checked={configuration.muscle_facts === "only"}
                onChange={() => on_change("muscle_facts", "only", true)}
              />
            </ExpandableControls>}
        </>}
    </div>
  )
}

export default AdvancedSettings
